/* eslint-disable jira/filename-case */

import { JSW_TMP_BACKLOG_BOARD_REGEXP } from '@jira/navigation-apps__atlassian-navigation-ui/src/NavigationConstants.tsx';
import { getLocation } from '@jira/ssr__browser-globals/src/getLocation.tsx';

export const shouldDisableGICFlagCreation: () => boolean = () => {
	const location = getLocation();
	if (!location) {
		return false;
	}
	return JSW_TMP_BACKLOG_BOARD_REGEXP.test(location.pathname);
};
